import React from "react";
import {APP} from '../../../../constants';
import {Dropdown, Menu} from "semantic-ui-react";
import {useIntl} from 'react-intl';

let subdomain = window.location.host.split('.')[0];

export const Languages = ({search}) => {

    let languageOptions = [
        {
            key: "pt",
            text: "Português",
            value: "pt"
        },
        {
            key: "en",
            text: "English",
            value: "en"
        }
    ];

    if(["europa", "italia"].includes(subdomain)){
        languageOptions.push({
            key: "it",
            text: "Italian",
            value: "it"
        });
    }

    // ,
    // {
    //     key: "es",
    //     text: "Spanish",
    //     value: "es"
    // },

    const placeholder = useIntl().formatMessage({id: 'Trocar Idioma'});

    return (
        <Menu.Item>
            <Dropdown
                placeholder={placeholder}
                selection
                options={languageOptions}
                selectOnBlur={false}
                value={APP.locale}
                onChange={
                    (e, {value}) => {

                        localStorage.setItem('_LOCALE', value);

                        let url = window.location.href.split('?');

                        console.log(url.length);
                        console.log(url);
                        console.log(search);
                        console.log(value);

                        if (url.length === 1) {

                            url = url + '?';
                        }else{

                            url = url[0];
                        }

                        console.log(url + search + "&" + value);

                        window.location.href = url + search + "&" + value;
                    }
                }
            />
        </Menu.Item>
    );
};
